module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/core-js/library/modules/_library.js
// module id = 100
// module chunks = 0